import React from "react";
import { WarningIcon } from "affinityIcons";
import { styled } from "styled-components";

const ResultWrapContainer = styled.div<{ $warning?: boolean }>`
  font-weight: bold;
  width: fit-content;
  color: ${({ $warning, theme }) => ($warning ? theme.colours.orange[500] : "inherited")};
`;

const HighlightResultWrapContainer = styled(ResultWrapContainer)`
  border-radius: 6px;
  background: ${(props) => props.theme.colours.orange[50]};
  margin-left: -0.3rem;
  margin-top: -0.3rem;
  margin-bottom: -0.3rem;
  padding: 0.1rem 0.3rem;
  align-self: center;
`;

export const ResultWrap: React.FC<
  React.ComponentProps<typeof ResultWrapContainer> &
    React.ComponentProps<typeof HighlightResultWrapContainer> &
    React.PropsWithChildren<{ warning?: boolean; highlight?: boolean }>
> = ({ children, warning, highlight, ...props }) => {
  const Container = highlight ? HighlightResultWrapContainer : ResultWrapContainer;
  return (
    <Container $warning={warning} {...props}>
      {children} {warning ? <WarningIcon /> : <></>}
    </Container>
  );
};
